$(document).ready(function(){  

  //filter work

  $("h2.widget-title").click(function () {
    if($(this).hasClass('active_h2_title'))
    {
      $(this).removeClass("active_h2_title");
      $(this).next('ul.widget-contentav').removeClass("active_ul_con");
    }
    else{
      $(this).addClass("active_h2_title");
      $(this).next('ul.widget-contentav').addClass("active_ul_con");
    }  
  });

  //thumb image click
  $('.custom_thimbnail_slider_desk').click(function(e){
    var thumb_img_link =  $(this).attr('data_image_thumb');
    console.log(thumb_img_link);

    $('.cstm_main_img').each(function(){
      var image_swa_url_new = $(this).children('.product-single__media').attr('data_main_img');
      //var image_swa_url_2= $(this).children('.product-single__media').attr('data_main_img');
      if(thumb_img_link == image_swa_url_new){
        $(this).removeClass('hide');
      }
      else{
        $(this).addClass('hide');
      }
    }); 
  });


  // footer accordian JS
  $('#accordion-demo').accordiom();
  $('#accordion-demo_pro').accordiom();

  //mobile country selector

  $('.dropdown').change(function(event){
    var val =  $(this).val();
    window.location.href = val;
  });

  jQuery(function() {
    jQuery('.swatch :radio').change(function() {
      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });
  });

  // product swatches script
  var selectCallBack = function(variant, selector){
    // BEGIN SWATCHES
    if (variant) {
      var form = jQuery('#' + selector.domIdPrefix).closest('form');
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.size()) {
          radioButton.get(0).checked = true;
        }
      }
    }
    // END SWATCHES

    if(variant && variant.available){
      jQuery("#addtocartbtn").removeAttr("disabled").removeClass("disabled");
      if(variant.price < variant.compare_at_price){
        jQuery("#price-preview").html(Shopify.formatMoney(variant.price, "{{ shop.money_format }}"));
      }
      else{
        jQuery("#price-preview").html(Shopify.formatMoney(variant.price, "{{ shop.money_format }}"));
      }
    }
    else{
      jQuery("#addtocartbtn").addClass("disabled").attr("disabled","disabled");
      var messages = variant ? "Sold Out" : "Unavailable";
      jQuery("#price-preview").text(messages);
    }
  }


  // alt tag feature product page

  //onload display matching images
  //   var clrload = $('.swatch-element.color.selectedcolor').attr('data-value');
  //   $('.cstm_media_thumbs').each(function(){
  //     var clralt = $(this).attr('data-alt');
  //     if(clralt == clrload){
  //       $(this).removeClass('hide');
  //     }
  //     if(clralt != clrload){
  //       $(this).addClass('hide');
  //     }

  //   }); 

  //   var opt = 0;
  //   $('.cstm_main_img').each(function(){
  //     var altclr = $(this).attr('data-alt');
  //     if(altclr != clrload){
  //       $(this).addClass('hide');
  //     }
  //     if(altclr == clrload){
  //       opt++;
  //       if(opt == 1){
  //         $(this).removeClass('hide');
  //       }
  //     }
  //   });

  //   //onclick display matching images
  //   $('.swatch-element.color > label').on('click',function(){
  //     console.log('color changed');
  //     $('.swatch-element.color').removeClass('selectedcolor');
  //     $(this).parent('.swatch-element.color').addClass('selectedcolor');

  //     var newclr = $('.swatch-element.color.selectedcolor').attr('data-value');

  //     $('.cstm_media_thumbs').each(function(){
  //       var clralt = $(this).attr('data-alt');
  //       if(clralt == newclr){
  //         $(this).removeClass('hide');
  //       }
  //       if(clralt != newclr){
  //         $(this).addClass('hide');
  //       }

  //     });


  //     var opt2 = 0;
  //   $('.cstm_main_img').each(function(){
  //     var altclr2 = $(this).attr('data-alt');
  //     if(altclr2 != newclr){
  //       $(this).addClass('hide');
  //     }
  //     if(altclr2 == newclr){
  //       opt2++;
  //       if(opt2 == 1){
  //         $(this).removeClass('hide');
  //       }
  //     }
  //   });



  //   });

  // collection filter
  $('.filters-opn').click(function(){
    $('.filtersdiv').slideToggle();
  });

  $(document).ready(function(){
    setTimeout(function(){ 

      $('.filter_off_color .advanced-filter').each(function(){
        var color = $(this).attr('data-img');
        var hover = $(this).attr('data-color');
        $(this).find('.link_to_color').attr('style',color);
        $(this).find('.link_to_color').text('');
        $(this).find('.link_to_color').removeAttr('title');
        $(this).find('.link_to_color').attr('title',hover);
      }); 

      setTimeout(function(){   
        $('.cust-coll-filter').each(function(){
          var title = $(this).find('.widget-title').text();

          $(this).find('.advanced-filter').each(function(){

            if($(this).hasClass('active_cus_filter')){

              var f_title = $(this).attr('data-active');
              var realnm = $(this).attr('data-name');
              var f_title1 = f_title.split('_'); 

              if(f_title != ""){
                $('.filters_a').show();
                $('.filters_a tbody').append('<tr><td>'+f_title1[0]+' : '+realnm+'</td><td class="clear_selected" data-remove="'+f_title+'">X</td></tr>');
              }
            }
          }); 
        });
      }, 500);
    }, 100);


    $(document).on('click','.clear_selected', function(){
      var remove = $(this).attr('data-remove');
      var trim_remove = $.trim(remove).replace(/\s+/g, '');
      $('.'+trim_remove+'_trigger a')[0].click(); 

    });


    /**** price sort ***/

    var $wrapper = $('.div_f_price');

    $wrapper.find('.filterchld').sort(function(a, b) {
      //console.log(+a.getAttribute('data-pln') - +b.getAttribute('data-pln'));
      return +a.getAttribute('data-pln') - +b.getAttribute('data-pln');
      //console.log(+a.getAttribute('data-pln') - +b.getAttribute('data-pln'));
    }).appendTo($wrapper);  



    //    var all_height = $('.cust-coll-filter:first-child').height();
    //    $('.cust-coll-filter').height(all_height);


    $('.prodcu_show_in').click(function(){
      $('.prodcu_show_in.pro_active').removeClass('pro_active');
      $(this).addClass('pro_active');
      var num = $(this).text();


      $('.section_width_change').each(function(){
        if(num == 1){
          //           if($(this).hasClass('small--one-half')){
          $(this).removeClass('small--one-half');
          $(this).addClass('small--one-whole');
          // }
        }
        if(num == 2){
          $(this).removeClass('small--one-whole');
          $(this).addClass('small--one-half');
        }
        if(num == 3){
          $(this).removeClass('medium-up--one-quarter');
          $(this).removeClass('medium-up--one-fifth');
          $(this).removeClass('medium-up--one-sixth');

          $(this).addClass('medium-up--one-third');

        }
        if(num == 4){
          $(this).removeClass('medium-up--one-third');
          $(this).removeClass('medium-up--one-fifth');
          $(this).removeClass('medium-up--one-sixth');

          $(this).addClass('medium-up--one-quarter');
        }
        if(num == 5){
          $(this).removeClass('medium-up--one-third');
          $(this).removeClass('medium-up--one-quarter');
          $(this).removeClass('medium-up--one-sixth');

          $(this).addClass('medium-up--one-fifth');
        }
        if(num == 6){
          $(this).removeClass('medium-up--one-third');
          $(this).removeClass('medium-up--one-quarter');
          $(this).removeClass('medium-up--one-fifth');

          $(this).addClass('medium-up--one-sixth');

        }
      });


    });
    if($(window).width() < 768){
      $('.size_2').addClass('pro_active');

    }



  });

  $(window).resize(function(){
    if($(window).width() < 768){
      $('.size_2').addClass('pro_active');

    }
  });


  $(document).ready(function(){
    var order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL' ];

    var $wrapper_size = $('.filter_off_size');
    $wrapper_size.find('.filterchld').sort(function(a, b) {
      var aSize = $(a).data('name'), bSize = $(b).data('name');
      return order.indexOf(aSize) - order.indexOf(bSize);
    }).appendTo($wrapper_size);



    // Configure/customize these variables.
    var showChar = 300;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Read more";
    var lesstext = "Show less";


    $('.read-more').each(function() {
      var content = $('.read-more').html();

      if(content.length > showChar) {

        var c = content.substr(0, showChar);
        var h = content.substr(showChar, content.length - showChar);

        var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

        $(this).html(html);
      }

    });

    $(".morelink").click(function(){
      if($(this).hasClass("less")) {
        $(this).removeClass("less");
        $(this).html(moretext);
      } else {
        $(this).addClass("less");
        $(this).html(lesstext);
      }
      $(this).parent().prev().toggle();
      $(this).prev().toggle();
      return false;
    });
  }); 


  // size chart JS



  $("ul.c-tabs__tabs>li").click(function(){
    $(this).addClass('active').siblings('li').removeClass('active');
    var index = $(this).index();
    $('.c-tabs__panel').eq(index).addClass('selected').siblings('div').removeClass('selected');
  })


  $(".topssizechartradiogroup>label").click(function(){
    $(this).addClass('active').siblings('label').removeClass('active');
    var index = $(this).index();
    $('.sizechart_incm_tops').eq(index).addClass('selected').siblings('div').removeClass('selected');
  })


  $(".dressessizechartradiogroup>label").click(function(){
    $(this).addClass('active').siblings('label').removeClass('active');
    var index = $(this).index();
    $('.sizechart_incm_dresses').eq(index).addClass('selected').siblings('div').removeClass('selected');
  })


  $(".bottomssizechartradiogroup>label").click(function(){
    $(this).addClass('active').siblings('label').removeClass('active');
    var index = $(this).index();
    $('.sizechart_incm_bottoms').eq(index).addClass('selected').siblings('div').removeClass('selected');
  })


  $(".swimwearsizechartradiogroup>label").click(function(){
    $(this).addClass('active').siblings('label').removeClass('active');
    var index = $(this).index();
    $('.sizechart_incm_swimwear').eq(index).addClass('selected').siblings('div').removeClass('selected');
  })
  
  $(".FlowerGirlsizechartradiogroup>label").click(function(){
        $(this).addClass('active').siblings('label').removeClass('active');
        var index = $(this).index();
        $('.sizechart_incm_FlowerGirl').eq(index).addClass('selected').siblings('div').removeClass('selected');
    })
  
  $(".Occasionsizechartradiogroup>label").click(function(){
        $(this).addClass('active').siblings('label').removeClass('active');
        var index = $(this).index();
        $('.sizechart_incm_Occasion').eq(index).addClass('selected').siblings('div').removeClass('selected');
    })

  $("#htm-btn-measure").click(function(){
    $(this).next("#htm-content-measure").animate({height: 'toggle', opacity: 'toggle'}, "");
    if($(this).find(".shrinkBox_open").hasClass("shrinkBox_close"))
    {$(this).find(".shrinkBox_open").removeClass("shrinkBox_close");}
    else
    { $(this).find(".shrinkBox_open").addClass("shrinkBox_close");}
  });
$(function(){
    $(".how-to-tabs>button").click(function(){
        $(this).addClass('active').siblings('button').removeClass('active');
        var index = $(this).index();
        $('.how-to-panel').eq(index).addClass('selected').siblings('div').removeClass('selected');
    })
  }); 

  // custom size

  $(".custom-size").click(function(){




    $(".custom-size-chart").show();
    $(".custom-size").addClass("custom-selected");
  });

  $( '.product-form' ).on( 'click', '.custom-not', function () {
    $(".custom-size-chart").hide();
    $(".custom-size").removeClass("custom-selected");
  });

  $('.custom-size-chart .size-form').find('.ccc').click(function(){
    var htm = $(this).find('.des').html();
    $('.defaultdes').html(htm);

  });



  //mobile slider
  $(".custom_thumb_slider").slick( {
    dots:!0, infinite:!1, arrows:!1, prevArrow:'<div class="custm_slick-left text-center"><i class="fas fa-chevron-left"></i></div>', nextArrow:'<div class="custm_slick-right text-center"><i class="fas fa-chevron-right"></i></div>', slidesToShow:1, slidesToScroll:1, responsive:[ {
      breakpoint:1024, settings: {
        slidesToShow: 1, slidesToScroll: 1, infinite: !1, dots: !0
      }
    }
    , {
      breakpoint:600, settings: {
        slidesToShow: 1, slidesToScroll: 1
      }
    }
    , {
      breakpoint:480, settings: {
        slidesToShow: 1, slidesToScroll: 1
      }
    }
    ]
  });

  // custom colors

  if ($(window).width() <= 767 ) {
    var color_count = 0;
    $('.custom_Colors_loop').each(function(i){
      color_count++;

      $(this).attr('data-ct-color', i);
    });

    if(color_count >= 8){
      $('.data_count_value_nw_swatch').text(color_count);
      $('.swatch_count_prd').click(function(){
        $('.custom_Colors_loop').css("display", "inline-block");
        $(this).hide();
        $('.hide_color_swatch').css("display", "inline-block");
      });
      $('.hide_color_swatch').click(function(){
        $('.custom_Colors.custom_Colors_loop').css("display", "none");
        $(this).hide();
        $('.swatch_count_prd').css("display", "inline-block");
      });
    }

  }

  $('.custom_Colors').click(function(){
    $('#swatch-0-chiffon-color').trigger('click');
    $('#swatch-0-satin-color').trigger('click');
    $('#swatch-0-taffeta-color').trigger('click');
    $('#swatch-0-organza-color').trigger('click');
    $('#swatch-0-charmeuse-color').trigger('click');
    $('#swatch-0-jersey-color').trigger('click');
    $('#swatch-0-satin-chiffon-color').trigger('click');
    $(".custom_Colors").removeClass('custom_color_selected');
    $(this).addClass('custom_color_selected');
    $(".custom_Colors").find('input').removeAttr('name');
    $(this).find('input').attr('name', 'properties[custom_color]')
  });

  $('.cust_swatch_element').click(function(){
    //price change on variant option
    var option_pice = $(this).attr("data_price");
    var compare_price = $(this).attr("data_com");
    // console.log(compare_price);
    $(".cstm_price").html(option_pice);
    $(".cstm_price_sale").html(compare_price);
    $(".cstm_price_sale_new").html(option_pice);

    if($(this).hasClass('color')){
      $('.custom_Colors.custom_color_selected').removeClass('custom_color_selected');
      $(".custom_Colors").find('input').removeAttr('name');
    }


    $('#bust > option').prop('selected',false);
    $('#bust > option:first').prop('selected',true);

    $('#waist > option').prop('selected',false);
    $('#waist > option:first').prop('selected',true);

    $('#hips > option').prop('selected',false);
    $('#hips > option:first').prop('selected',true);

    $('#hollow > option').prop('selected',false);
    $('#hollow > option:first').prop('selected',true);

    $('#hollow2 > option').prop('selected',false);
    $('#hollow2 > option:first').prop('selected',true);

    $('#length > option').prop('selected',false);
    $('#length > option:first').prop('selected',true);

  });

  //collection page

  $(document).ready(function(){
    $(".pages_of select").change(function(){
      var  val = $(this).val();
      var pageURL =  window.location.href.split('?')[0];
      window.location.href = pageURL+"?page="+val;

    });

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    };
    var page = getUrlParameter('page');

    //console.log(page);
    if(page == undefined){
    }
    else{
      $('.pages_of select').val(page).attr('selected');
    }

  });


  //product slider JS
  $(".custom_thumb_sliderDesk").slick({
    dots:!0, 
    infinite:!1, 
    arrows:!0, 
    prevArrow:'<div class="custm_slick-left text-center"><i class="fas fa-chevron-left"></i></div>', 
    nextArrow:'<div class="custm_slick-right text-center"><i class="fas fa-chevron-right"></i></div>', 
    slidesToShow:4, 
    slidesToScroll:3,
    vertical: true,
    verticalSwiping: true
  }); 

//slick product mobile dots contains video 
  $('.slick-slide').each(function(){
    if ( $(this).children("div").children("div").hasClass('cstm_video_part_mob') ) {
      var  var_inx = $(this).attr("data-slick-index");
      $('ul.slick-dots li').eq(var_inx).addClass('active_video');
    }
  });


//   $('.cust_swatch_element').click(function(){

//     //option change click

//     var color_name = $(this).attr("data_sku");
//     $("span.variant-sku").text(color_name);
//   }); 

$(".font-size--down-1").on("click", function() {
    var s=$(document).height()-$(window).height();
    console.log(s);
    var i=s*(18/99);
    console.log("scrollAmount: "+i), jQuery("html, body").animate( {
        scrollTop: i
    }
    , 800)
});




});//document ready end